import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuard } from "~/features/auth/components/route-guard";

function DashboardLayout() {
  return (
     <RouteGuard>
       <main
        className="flex w-full flex-col justify-center"
        role="main"
        aria-label="Dashboard layout"
      >

        <Outlet />
      </main>
     </RouteGuard>
  );
}

export const Route = createFileRoute("/(dashboard)/dashboard")({
  component: DashboardLayout,
  errorComponent: ({ error }: { error: Error }) => (
    <div
      role="alert"
      className="flex min-h-screen items-center justify-center p-4"
    >
      <div className="text-center">
        <h1 className="text-2xl font-bold">Dashboard Error</h1>
        <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),
});
